<template>
  <div>
    <div class="profile-img" style="position: relative">
      <div
        :class="loading ? 'uploading' : ''"
        class="camera-overlay"
        @click="canAddTransaction ? $refs.imageInput.click() : '' "
        v-can="{ slug: 'ngo-profile', action: 'U' }"
      >

        <b-spinner
          v-if="loading"
          variant="light"
          class="camera-icon mt-25"
          style="z-index: 2"
        ></b-spinner>

        <feather-icon
          v-else
          color="#EEEEEE"
          icon="CameraIcon"
          size="35"
          class="camera-icon"
        />
      </div>

      <b-img
        style="height: 100%; width: 100%; position: absolute;"
        :src="img"
        rounded
        fluid
        alt="profile photo"
      />
      <!-- <b-alert show variant="warning" class="stateClass">بإنتظار المطابقة</b-alert> -->
      
      <!-- <b-button
      @click="commentsModal = true"
      variant="danger"
      class="stateClassconfuse"
      >تم الرفض,ردود الوزارة <feather-icon icon="ChevronLeftIcon" /> </b-button> -->
      
      <input
        type="file"
        @change="loadImage($event)"
        accept="image/*"
        name="image-ngo"
        style="display: none"
        ref="imageInput"
      />
    </div>
    <!-- v-if="accountForm.feedback_content" -->
    <b-modal
      size="lg"
      v-model="commentsModal"
      hide-backdrop
      footer-class="removed"
      title="رد الوزارة على معاملة اعتماد شعار"
    >
      <b-card-text class="p-1">
        <ul>
          <li>12</li>
        </ul>
        <!-- <div v-html="accountForm.feedback_content"></div> -->
      </b-card-text>
    </b-modal>
    <b-modal
      v-model="cropModal"
      centered
      title="تعديل شعار المنظمة"
      id="modal-rouls"
      footer-class="removed"
      cancel-variant="outline-secondary"
      size="lg"
      no-close-on-backdrop
      static
    >
      <div class="upload-example">
        <cropper
          ref="cropper"
          class="upload-example-cropper"
          :src="image.src"
          :stencil-props="{
            aspectRatio: 1 / 1,
          }"
        />

        <hr />

        <b-button variant="success" @click="onConfirmCrop()"> تأكيد </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import "vue-advanced-cropper/dist/style.css";
import { Cropper } from "vue-advanced-cropper";
import { BButton, BImg, BSpinner, BModal , BAlert } from "bootstrap-vue";
// This function is used to detect the actual image type,
import { getMimeType } from "@/utils/utils";
import { mapGetters } from "vuex";

export default {
  components: {
    Cropper,
    BButton,
    BImg,
    BSpinner,
    BModal,
    BAlert
  },
  props: {
    img: String,
    loading: Boolean,
  },
  data() {
    return {
      image: {
        src: null,
        type: null,
      },
      cropModal: false,
      commentsModal :false ,
    };
  },
  
  computed: {
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),
  },

  methods: {
    onConfirmCrop() {
      this.$emit("confirm", this.$refs.cropper.getResult());
      this.cropModal = false;
    },
    crop() {
      const { canvas } = this.$refs.cropper.getResult();
      canvas.toBlob((blob) => {}, this.image.type);
    },
    reset() {
      this.image = {
        src: null,
        type: null,
      };
    },
    loadImage(event) {
      const { files } = event.target;
      if (files && files[0]) {
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        const blob = URL.createObjectURL(files[0]);
        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = {
            src: blob,
            type: getMimeType(e.target.result, files[0].type),
          };
        };
        reader.readAsArrayBuffer(files[0]);
      }
      this.cropModal = true;
    },
  },
  destroyed() {
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src);
    }
  },
};
</script>

<style lang="scss">
[dir] .vue-bounding-box__handler {
  direction: rtl !important;
}
[dir] .upload-example {
  .vue-advanced-cropper {
    direction: ltr;
  }
  * {
    direction: ltr;
  }
}
[dir="rtl"] .vue-handler-wrapper--east-south {
  cursor: se-resize;
}
[dir="rtl"] .vue-handler-wrapper--west-south {
  cursor: sw-resize;
}
[dir="rtl"] .vue-handler-wrapper--west-north {
  cursor: nw-resize;
}
[dir="rtl"] .vue-handler-wrapper--east-north {
  cursor: ne-resize;
}
.uploading {
  opacity: 0.8 !important;
}
.camera-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0;
  transition: all 0.3s ease;
  cursor: pointer;
  user-select: none;
  &:active {
    background-color: gray;
  }
  &:hover {
    opacity: 0.8;
  }
  z-index: 1;
}
.camera-icon {
  position: absolute;
  left: 35%;
  top: 35%;
}
// me
.stateClassconfuse , 
.stateClass{
  position: relative;
  text-align: center;
  padding: 5px;
  top: 76%;
  z-index: 1000000;
}
.stateClassconfuse{
  font-size: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
